














































































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';
import MainButton from '@/main-components/common/MainButton.vue';
import ModalGradePaper from '@/main-components/common/modal/ModalGradePaper.vue';
import ModalSignInUp from '@/main-components/common/modal/ModalSignInUp.vue';
import { GradePaper } from '@/resource/grade/grade.model';
import { axios } from '@/utils/axios';
import CollectionLoading from '@/components/collections/CollectionLoading.vue';
import truncateString from '@/utils/common/truncate';
import { getToken } from '@/utils/cookie';

@Component({
  components: {
    MainButton,
    ModalGradePaper,
    ModalSignInUp,
    CollectionLoading,
  },
  metaInfo(this: GradePapersPage): MetaInfo {
    return {
      title: `Auto Grade |`,
      meta: [
        ...seoDefault({
          title: `Auto Grade | Mysoalan`,
          description: '',
        }),
      ],
    };
  },
})
export default class GradePapersPage extends Vue {
  isLoading = true;
  gradePapers: GradePaper[] = [];

  openModalGradePaper: any = null;

  get isLoggedin() {
    return getToken() ? true : false;
  }

  created() {
    this.getGradePapers();
  }

  openModalGradePaperAdd(openModal: any) {
    this.openModalGradePaper = openModal;
  }

  async getGradePapers() {
    this.isLoading = true;
    try {
      const { data } = await axios.get('/grade-papers/me');

      if (data) {
        this.gradePapers = data as GradePaper[];
      }
    } catch (error) {
      console.log(error);
    }

    this.isLoading = false;
  }

  gradePaperClicked(gradePaper: GradePaper) {
    this.$router.push(`/auto-grades/${gradePaper.uuid}`);
  }

  truncateName(gradePaper: GradePaper) {
    return truncateString(gradePaper.name, 30);
  }

  createNewPaperClick() {
    this.$sendMpEvent({ event: this.$mp_value.AutoGrade_AddPaperClick });

    if (this.isLoggedin) {
      this.$sendMpEvent({ event: this.$mp_value.AutoGrade_ModalAddPaper });
      this.openModalGradePaper && this.openModalGradePaper();
    } else {
      this.$sendMpEvent({ event: this.$mp_value.AutoGrade_Register });
      const modalSignUp = this.$refs.modalSignUp as any;
      modalSignUp.openModal();
    }
  }

  refreshPage() {
    this.$router.go(0);
  }
}
